<div class="dynamicForm_alignment" [formGroup]="group">
  <div [formArrayName]="field.labelCode">
    <div class="search_field">
      <mat-form-field class="controls-alignment">
        <mat-label>{{field.labelCode}}</mat-label>
        <input [required]="isRequiredField" matInput [formControl]="selectAndSearchForCheckBox" type="text" autocomplete="off"
          [matAutocomplete]="auto" tabindex="0">
          <mat-autocomplete  #auto="matAutocomplete" (opened)="broadcastService.onOpenDropDownOrderForm()" (closed)="broadcastService.onCloseDropDownOrderForm()"
            tabindex="0" panelWidth="60%" (optionSelected)="checkBoxSelectionChanged($event)">
            @for (element of (filteredCheckBoxValues | async); track element) {
              <mat-option value="{{element}}" [id] = "element"
                class="mat-option-style">
                <span>{{element}}</span>
              </mat-option>
            }
            @if (noData) {
              <mat-option>
                No records found.
              </mat-option>
            }
          </mat-autocomplete>
        </mat-form-field>
      </div>
      @if (group.get(field.labelCode).touched && group.get(field.labelCode).hasError('invalidCheckboxes')) {
        <mat-error style="font-size: 75%;">{{field.labelName}} is mandatory</mat-error>
      }
      @for (check of sortedOptions; track check; let i = $index) {
        <div class="check-box-cover">
          <mat-checkbox [formControlName]="i"
          (change)="check.isSelected = $event.checked;
          setCheckBoxValue($event,check, i)" class="max-width-checkbox">
            {{check.value}}
          </mat-checkbox>
        </div>
      }
    </div>
  </div>